module.exports = __webpack_public_path__ + "static/asteroids-d85b153e8fcaddb1490c0e8a061e6a0d.png";